import axios from "axios";
import { auth } from "../firebase/firebase.config";

export function setupAxiosInterceptor() {
  axios.interceptors.request.use(
    async (config) => {
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        config.headers["X-Auth-Token"] = token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
}
